import { render, staticRenderFns } from "./FinanceSalarySliceShowTableTotal.vue?vue&type=template&id=3973536c&"
import script from "./FinanceSalarySliceShowTableTotal.vue?vue&type=script&lang=js&"
export * from "./FinanceSalarySliceShowTableTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports